export default "__VITE_ASSET__Dg4qk8RM__"